import { useSelector } from 'react-redux';
import { CommonRootState } from '@pec/aion-ui-core/combineReducers';
import { ActivityAction, ActivityResourceName } from '@pec/aion-ui-core/interfaces/activities';
import { UserInfoActivitiesType } from '@pec/aion-ui-core/interfaces/userInfo';
import { hasPermission } from '@pec/aion-ui-core/actions/userInfo';

const { User } = UserInfoActivitiesType;

export function useUserPermission() {
  const { userInfo } = useSelector((state: CommonRootState) => state.userInfo);

  const hasGlobalPermission = (action: ActivityAction, resourceName: ActivityResourceName) =>
    hasPermission(userInfo, action, resourceName);

  const hasUserPermission = (action: ActivityAction, resourceName: ActivityResourceName) => {
    if (!userInfo) {
      return false;
    }

    return userInfo.activities.some(
      ({ type, activities }) => type === User && activities[resourceName]?.includes(action)
    );
  };

  return {
    hasGlobalPermission,
    hasUserPermission
  };
}
